<template>
  <div
    v-if="query?.expires && query?.signature"
    class="fixed bottom-0 left-0 bg-[var(--p-primary-color)] px-2 py-1 text-white z-[999]"
  >
    {{ $t('Dočasný náhled platný do') }}
    {{
      Intl.DateTimeFormat(locale.replace('_', '-'), {
        dateStyle: 'long',
        timeStyle: 'short',
      }).format(new Date(new Date(Number(query.expires) * 1000)))
    }}
  </div>
</template>
<script setup lang="ts">
const { locale } = useI18n()

const route = useRoute()
const query = shallowRef<{ expires?: string; signature?: string }>({})

watch(
  () => route.fullPath,
  () => {
    query.value = route.query
  },
  { immediate: true }
)
</script>
